import { useEffect, useState } from 'react';

import FieldsGrid from 'components/FieldsGrid';
import Page from 'components/Page';

import useFields from 'hooks/useFields';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FieldsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { fetch, fields = [] } = useFields();
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetch().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetch().next();

    return (
        <Page className={styles.fieldsPage} testId={testId}>
            <FieldsGrid onNext={hasMore ? handleNext : undefined} rows={fields} />
        </Page>
    );
};

export default FieldsPage;
